import React from "react";
import { useRouteMatch } from "react-router-dom";

import PigDetailsSection from "../PigDetailsSection";
import ScreenLayout from "../ScreenLayout";
import MobilePageTitle from "../MobilePageTitle";
import { ACTIVE_URL, COMPLETED_URL } from "../PigTrackingPage";

import { usePigDetails } from "./usePigDetails";

import styles from "./index.module.scss";
import LoadingWrapper from "../LoadingSpinnerWrapper";

import { tmPigName } from "../../helpers/pigMetadata";

const PigDetailsPage = () => {
  const match = useRouteMatch<{ id: string }>();
  const { id } = match.params;
  const { pigData, status } = usePigDetails(id, true);
  const completed = match.url.includes("history");

  const runDetails = pigData ? pigData.pigRun : undefined;

  if (!runDetails) return <LoadingWrapper loading />;

  const breadCrumbs = {
    text: completed ? "Completed Runs" : "Active Runs",
    url: completed ? COMPLETED_URL : ACTIVE_URL
  };

  const latest = runDetails.updates[0]
    ? runDetails.updates[0].pipelineName
    : `error`;

  const tmName = tmPigName(runDetails);
  const pigName = tmName
    ? tmName
    : `${runDetails.pipeline.name}${
        latest !== runDetails.pipeline.name ? ` to ${latest}` : ``
      }`;
  const pageTitle = `${pigName} - Run ${runDetails.runId}`;

  return (
    <ScreenLayout title={pageTitle} breadCrumbs={breadCrumbs}>
      <div className={styles.HeaderWrapper}>
        <MobilePageTitle page={pageTitle} breadCrumbs={breadCrumbs} />
      </div>
      <PigDetailsSection
        pigRun={runDetails}
        loading={status === "loading"}
        completed={completed}
      />
    </ScreenLayout>
  );
};

export default PigDetailsPage;
